import React from 'react';
import { useTheme, ITheme } from 'src/theme';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';
import IconDownload from '@assets/icon/download.svg';

import Icon from '@components/Icon';
import ContainerBlock from '@components/ContainerBlock';
import Text from '@components/Text';
import Link from '@components/Link';
import Heading from '@components/Heading';

const FlexRow = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
`

const FlexBox = styled.div`
  display: flex;
  margin-bottom: 15px;
`;
const IconMargin = css`
  margin-right: 24px;
  margin-top: 8px;
`

const TextIcon = styled.div`
  min-width: 14px;
  width: 14px;
  color: #444444;
`

export interface PlanInformationProps {
  brochureUrl?: string;
}

function PlanInformation({ brochureUrl }: PlanInformationProps) {
  const theme: ITheme = useTheme();
  return (
    <ContainerBlock
      background={theme.colors.grey[200]}
      boxShadow="0 2px 2px 0 rgba(204, 204, 204, 0.5)"
      borderTop={`3px solid ${theme.colors.primary}`}
      padding="25px 20px"
      paddingTablet="25px 30px"
    >
      <Heading variant="smallTitle" fontWeight={600} color={theme.colors.grey[400]} margin="0 0 20px">Singlife Simple Term</Heading>
      <FlexRow>
        <Icon className={IconMargin} name="confirmation-tick"/>
        <div>
          <Text><b>Up to S$500,000 lump-sum payout</b> upon death, Terminal Illness or Total and Permanent Disability to help you or your loved ones tide through a difficult period</Text>
        </div>
      </FlexRow>
      <FlexRow>
        <Icon className={IconMargin} name="confirmation-tick"/>
        <div>
          <Text>Premiums* start <b>from S$0.37** per day</b> for S$500,000 coverage</Text>
        </div>
      </FlexRow>
      <FlexRow>
        <Icon className={IconMargin} name="confirmation-tick"/>
        <div>
          <Text><b>Renew your plan yearly</b> for non-stop coverage until you’re 86 years old</Text>
        </div>
      </FlexRow>
      <FlexRow>
        <Icon className={IconMargin} name="confirmation-tick"/>
        <div>
          <Text><b>Option to add on</b> Critical Illness Cover (2025) and Personal Accident Cover for more well- rounded protection</Text>
        </div>
      </FlexRow>
      <FlexBox>
        <TextIcon>*</TextIcon>
        <Text margin="0"> As this is a yearly renewable plan, the renewal premium payable will be based on the life assured’s attained age at the policy renewal date and the premium increases with age.</Text>
      </FlexBox>
      <FlexBox>
        <TextIcon>**</TextIcon>
        <Text margin="0">Premium at S$0.37 is based on coverage for a non-smoking female, between 1 and 35 years old, with annual premium of S$136 divided over 365 days, rounded down to the nearest cents. </Text>
      </FlexBox>
      <Text margin="0 0 15px"> All ages mentioned refer to age next birthday. </Text>
      <Link text="Download brochure" icon={IconDownload} slotIcon="start" target="_blank" rel="noopener noreferrer" url={brochureUrl} />
    </ContainerBlock>
  );
};

export default PlanInformation;
